import React, { Component } from 'react';
import Store from './Store.js'
import Topic from './ui/Topic.js'

class PackageTopic extends Component {
    render() {
        let store = new Store();
        const items = this.props.itemNames.map((name) => {
            let item = store.breadcrumbItem(this.props.baseName + "." + name);
            return { title: name, link: item.link || item.fullName }
        });
        return (
            <Topic title={this.props.title} items={items}/>
        );
    }
}

export default PackageTopic;



// WEBPACK FOOTER //
// ./src/reference/PackageTopic.js